import { useEffect } from "react";
import {
  Border,
  Chat,
  ChatFlex,
  NoChat,
  NoSearchChat,
  SearchBar,
} from "./style";
import { BiSearch } from "react-icons/bi";
import { FiXCircle } from "react-icons/fi";
import { useState } from "react";
import axios from "axios";

interface ChatComponentProps {
  onSelect: (data: DataItem) => void;
  conversationId: string;
}

interface DataItem {
  image: string;
  userName: string;
  messages: string;
  chatId: string;
  userId: string;
  conversationId: string;
}

interface InboxMessage {
  message: MessageItem[];
}

interface Messenger {
  chatId: string;
  username: string;
  image: string;
  userId: string;
}

interface MessageItem {
  conversationId: string;
  messenger: Messenger;
  lastMessage: string | null;
  updatedDate: string;
}

const Chats = ({ onSelect, conversationId }: ChatComponentProps) => {
  const [searchText, setSearchText] = useState("");
  const storedToken = sessionStorage.getItem("token");
  const myChatId = sessionStorage.getItem("chatId");
  const token = `Bearer ${storedToken}`;
  const [inboxMessage, setInboxMessage] = useState<InboxMessage>({
    message: [],
  });

  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_ENDPOINT}/inbox-message`, {
        headers: Authorization,
      })
      .then((res: any) => {
        console.log(res.data);
        setInboxMessage(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

  const handleUserClick = (message: MessageItem) => {
    const user: DataItem = {
      userName: message.messenger.username,
      image: message.messenger.image,
      messages: "",
      chatId: "",
      userId: message.messenger.userId,
      conversationId: message.conversationId,
    };
    onSelect(user);
  };

  const filteredMessages = inboxMessage.message.filter((message) =>
    message.messenger.username.toLowerCase().includes(searchText.toLowerCase())
  );

  const clearSearch = () => {
    setSearchText("");
  };

  const newPrivateChat = () => {
    // newPrivateChat function
  };

  const convertTimeTo12HoursFormat = (timeString: string) => {
    const date = new Date(timeString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  return (
    <div>
      <Border>
        <SearchBar>
          <BiSearch size={20} />
          <input
            type="text"
            placeholder="Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          {searchText && (
            <FiXCircle
              onClick={clearSearch}
              size={22}
              style={{ cursor: "pointer", color: "#d46666" }}
            />
          )}
        </SearchBar>

        <ChatFlex>
          {inboxMessage.message.length > 0 ? (
            <>
              {searchText ? (
                <>
                  {filteredMessages.length > 0 ? (
                    <>
                      {filteredMessages.map((message, index) => (
                        <div
                          key={index}
                          onClick={() => handleUserClick(message)}
                        >
                          <Chat>
                            <div>
                              {message && (
                                <>
                                  <img
                                    src={
                                      message.messenger.image ||
                                      "image/Default_Profile.png"
                                    }
                                    alt="avatar"
                                  />
                                  <div>
                                    <span>{message.messenger.username}</span>
                                    <span>{message.lastMessage}</span>
                                  </div>
                                </>
                              )}
                            </div>
                            <p>
                              {message && (
                                <>
                                  {convertTimeTo12HoursFormat(
                                    message.updatedDate
                                  )}
                                </>
                              )}
                            </p>
                          </Chat>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      <NoChat>
                        <span>No chats yet.</span>
                        <span>
                          Chat with contacts who have HushTalk installed on
                          their phone.
                        </span>
                        <button onClick={newPrivateChat}>
                          new private chat
                        </button>
                      </NoChat>
                    </>
                  )}
                </>
              ) : (
                inboxMessage.message.map((message, index) => (
                  <div key={index} onClick={() => handleUserClick(message)}>
                    <Chat>
                      <div>
                        <img
                          src={
                            message.messenger.image ||
                            "image/Default_Profile.png"
                          }
                          alt="Avatar"
                        />
                        <div>
                          <span>{message.messenger.username}</span>
                          <span>{message.lastMessage}</span>
                        </div>
                      </div>
                      <p>{convertTimeTo12HoursFormat(message.updatedDate)}</p>
                    </Chat>
                  </div>
                ))
              )}
            </>
          ) : (
            <>
              <NoChat>
                <span>No chats yet.</span>
                <span>
                  Chat with contacts who have HushTalk installed on their phone.
                </span>
                <button onClick={newPrivateChat}>new private chat</button>
              </NoChat>
            </>
          )}
        </ChatFlex>
      </Border>
    </div>
  );
};

export default Chats;
